import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoIconComponent } from './info-icon.component';
import { TooltipModule } from 'ng2-tooltip-directive';

@NgModule({
    imports: [CommonModule, TooltipModule],
    declarations: [InfoIconComponent],
    exports: [InfoIconComponent],
})
export class InfoIconModule {}
